// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
    CheckboxesControl,
    InputControl,
    RadioButtonsControl,
    SelectControl,
    DatePickerControl,
} from "../../../molecules";
import {
    Box,
    FormControl,
    Stack,
    Typography,
    Autocomplete,
    TextField,
    useTheme,
    useMediaQuery,
    FormGroup,
    Switch,
    FormLabel,
    FormControlLabel,
    Divider,
    Tabs,
    Tab,
    Checkbox,
    Select,
    MenuItem
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { Button, ComboboxWithFreeText, Loading, ComboboxState } from "../../../atoms";
import {
    useGetMerchantCategoryList,
    useMerchantAdd,
    useGetMerchantTypeList,
    useGetPosTypeList,
    useGetAllMerchantList,
    useGetCommissionProfileList,
    useGetCityList,
    useGetTaxAdministrationList,
    useGetMerchantStatusList,
    IMerchantAddRequest,
    IMerchant,
    useMerchantUpdate,
    useAuthorization,
    useGetAnnulmentCodeList,
    useGetIntegrationTypes,
    useGetMerchantUserPortfolioList,
    useGetAllSectorsQuery,
    useGetGibUserList
} from "../../../../hooks";
import { useGetMerchantPassiveReasons } from "../../../../hooks/merchant/useGetMerchantPassiveReasons";
import { useEffect, useMemo, useState } from "react";
import { useUserMerchantId } from "../Merchant.state";
import { useSetSnackBar } from "../../../../store/Snackbar.state";
import {
    firstStepFormSchema,
    firstStepFormSchemaPassive,
    FirstStepFormValuesType,
    firstStepInitialValues,
} from "../_formTypes";
import { zodResolver } from "@hookform/resolvers/zod";
import { default as dayjs } from "dayjs";
import { useUserInfo } from "../../../../store/User.state";
import { MerchantAddFormAuthorizationSection, MerchantAddFormLimitSection, MerchantAddFormLimitSectionFormStates, MerchantAddFormTypeSection, MerchantAddFormTypeSectionFormStates } from '../components';
import { MerchantAddFormPartnerStep } from "../MerchantAddFormPartnerStep";
import { MerchantAddFormAddressStep } from "../MerchantAddFormAddressStep";
import { MerchantAddFormBankStep } from "../MerchantAddFormBankStep";
import { MerchantAddFormCurrencyStep } from "../MerchantAddFormCurrencyStep";
import { MerchantAuthorizationForm } from "../MerchantAuthorizationForm";
import { MerchantSpecialSettingsTab } from './tabs';
import { styled } from '@mui/material/styles';
import { MerchantAccount } from '../MerchantAccount';
import { MerchantBankAuthorizationPage } from "../../bank";
// { control, reset, handleSubmit, setValue, getValues, watch, errors }

const ScrollBox = styled(Box)(({ theme }) => ({
    overflowX: 'auto',
    overflowY: 'hidden',
    whiteSpace: 'nowrap',
    borderBottom: `1px solid ${theme.palette.divider}`,
}));

type MerchantAddFormCompanyStepProps = {
    onNext: () => void;
    merchant?: IMerchant;
    allData?: any;
    setAllData?: any;
};

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box >{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const MerchantSettings = ({ merchant, allData, setAllData, merchantId }) => {

    return <>
        <_MerchantMainInformation merchant={allData} allData={allData} setAllData={setAllData} merchantId={merchantId} />
    </>
}

const _MerchantTabs = ({ merchant, allData, setAllData, control, reset, setValue, getValues, watch, errors, formState, setFormState, formStateLimit, setFormStateLimit, merchantId }) => {
    const [value, setStateValue] = useState(0);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setStateValue(newValue);
    };

    return <Box sx={{ width: '100%' }}>
        <ScrollBox sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" variant="scrollable" scrollButtons="auto">
                <Tab sx={{ width: '100%', maxWidth: 200 }} label="Yetkili Kişi Bilgileri" {...a11yProps(0)} />
                <Tab sx={{ width: '100%', maxWidth: 200 }} label="Adres Bilgileri" {...a11yProps(1)} />
                <Tab sx={{ width: '100%', maxWidth: 200 }} label="Banka Bilgileri" {...a11yProps(2)} />
                <Tab sx={{ width: '100%', maxWidth: 200 }} label="Para Birimi Kısıtlama" {...a11yProps(3)} />
                <Tab sx={{ width: '100%', maxWidth: 200 }} label="Özel İşlemler" {...a11yProps(4)} />
                <Tab sx={{ width: '100%', maxWidth: 200 }} label="Cari Bilgileri" {...a11yProps(5)} />
                <Tab sx={{ width: '100%', maxWidth: 200 }} label="Üye İşyeri Banka Yetkilendirme" {...a11yProps(6)} />
            </Tabs>
        </ScrollBox>
        <CustomTabPanel value={value} index={0}>
            <MerchantAddFormPartnerStep merchant={allData} setAllData={setAllData} allData={allData} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
            <MerchantAddFormAddressStep merchant={allData} setAllData={setAllData} allData={allData} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
            <MerchantAddFormBankStep merchant={allData} setAllData={setAllData} allData={allData} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
            <MerchantAddFormCurrencyStep merchant={allData} setAllData={setAllData} allData={allData} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={4}>
            <MerchantSpecialSettingsTab merchant={merchant} allData={allData} setAllData={setAllData} formState={formState} setFormState={setFormState} control={control} reset={reset} formStateLimit={formStateLimit} setFormStateLimit={setFormStateLimit} getValues={getValues} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={5}>
            <MerchantAccount merchant={allData} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={6}>
            <MerchantBankAuthorizationPage merchantId={merchantId || allData?.merchantId} />
        </CustomTabPanel>
    </Box>
}

const integratorList = [
    {
        label: "ICE Teknoloji",
        value: "30"
    }
] as const;

const _MerchantMainInformation = ({
    merchant,
    onNext,
    allData,
    setAllData,
    merchantId // <-- ekle
}: MerchantAddFormCompanyStepProps & { merchantId?: number }) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const { showCreate } = useAuthorization();
    const { mutate: addMerchant, isLoading } = useMerchantAdd();
    const { mutate: updateMerchant, isLoading: updateLoading } =
        useMerchantUpdate();
    const [test, setMerchantId] = useUserMerchantId();
    const [taxAdministrations, setTaxAdministrations] = useState([]);
    const { data: rawMerchantStatus, isLoading: isMerchantStatusLoading } =
        useGetMerchantStatusList({});
    const { data: rawMerchantTypes, isLoading: isMerchantTypeLoading } =
        useGetMerchantTypeList({});
    const { data: rawIntegraionTypes, isLoading: isIntegrationTypesLoading } =
        useGetIntegrationTypes({
            page: 0,
            size: 25,
            orderByDesc: true,
            orderBy: 'CreateDate'
        });

    const { data: rawPosTypes, isLoading: isPosTypeLoading } = useGetPosTypeList(
        {}
    );
    const [userInfo] = useUserInfo();
    const { data: rawMerchantList, isLoading: isMerchantListLoading } =
        useGetAllMerchantList("ACTIVE");
    const {
        data: rawMerchantCategoryList,
        isLoading: isMerchantCategoryLoading,
    } = useGetMerchantCategoryList({});
    const {
        data: rawCommissionProfileList,
        isLoading: isCommissionProfileListLoading,
    } = useGetCommissionProfileList({});
    const { data: rawCityList, isLoading: isCityListLoading } = useGetCityList(
        {}
    );
    const {
        data: rawSectorList,
        isLoading: isSectorLoading,
    } = useGetAllSectorsQuery({
        page: 1,
        size: 9999
    });

    const [isPassiveSelected, setIsPassiveSelected] = useState(false);

    const { control, reset, handleSubmit, setValue, getValues, watch, errors } =
        useForm<FirstStepFormValuesType>({
            resolver: zodResolver(isPassiveSelected ? firstStepFormSchemaPassive : firstStepFormSchema),
            defaultValues: firstStepInitialValues,
            mode: 'onChange'
        });

    const { data: rawUserPortfolioList } = useGetMerchantUserPortfolioList();

    const { mutate: getTaxAdministrationList, isLoading: isTaxListLoading } =
        useGetTaxAdministrationList();
    const { data: rawAnnulmentCode, isLoading: isAnnulmentCodeLoading } = useGetAnnulmentCodeList({});
    const { data: rawMerchantPassiveReasons, isLoading: isMerchantPassiveReasonsLoading } = useGetMerchantPassiveReasons();
    const [gbAliasList, setGbAliasList] = useState([] as any);
    const { mutate: rawGbAliasList, isLoading: isGetGbAliasLoading } = useGetGibUserList(); // Your API hook
    const taxNumberWatch = watch('taxNumber');
    const [isTaxAndInvoiceGbAliasValid, setIsTaxAndInvoiceGbAliasValid] = useState(true);
    const [isTaxAndEArchiveGbAliasValid, setIsTaxAndEArchiveGbAliasValid] = useState(true);
    const integratorGbAlias = watch('integratorGbAlias');
    const integratorEArchiveGbAlias = watch('integratorEArchiveGbAlias');

    useEffect(() => {
        if (taxNumberWatch?.length === 10) {
            rawGbAliasList({
                taxNumber: taxNumberWatch
            }, {
                onSuccess(data) {
                    const tempData = data?.data?.map(
                        (item: string) => {
                            return {
                                label: item,
                                value: `${item}`,
                            };
                        }
                    );

                    // if (merchant.integratorGbAlias && tempData.find((item) => item.value === merchant.integratorGbAlias)) {
                    //     setIsTaxAndInvoiceGbAliasValid(true);
                    // } else if (merchant.integratorGbAlias && !tempData.find((item) => item.value === merchant.integratorGbAlias)) {
                    //     setIsTaxAndInvoiceGbAliasValid(false);
                    // }

                    // if (merchant.integratorEArchiveGbAlias && tempData.find((item) => item.value === merchant.integratorEArchiveGbAlias)) {
                    //     setIsTaxAndEArchiveGbAliasValid(true);
                    // } else if (merchant.integratorEArchiveGbAlias && !tempData.find((item) => item.value === merchant.integratorEArchiveGbAlias)) {
                    //     setIsTaxAndEArchiveGbAliasValid(false);
                    // }

                    setGbAliasList(tempData);
                },
                onError(error) {
                    setGbAliasList([]);
                }
            });
        } else {
            setGbAliasList([]);
        }
    }, [taxNumberWatch]);

    useEffect(() => {
        if (integratorGbAlias && gbAliasList.length > 0) {
            const isValid = gbAliasList.some(item => item.value === integratorGbAlias);
            setIsTaxAndInvoiceGbAliasValid(isValid);
        }
    }, [integratorGbAlias, gbAliasList]);

    useEffect(() => {
        if (integratorEArchiveGbAlias && gbAliasList.length > 0) {
            const isValid = gbAliasList.some(item => item.value === integratorEArchiveGbAlias);
            setIsTaxAndEArchiveGbAliasValid(isValid);
        }
    }, [integratorEArchiveGbAlias, gbAliasList]);

    const selectedMerchantStatus = watch("merchantStatusType");

    useEffect(() => {
        setIsPassiveSelected(selectedMerchantStatus === "PASSIVE");
    }, [selectedMerchantStatus]);
    // const selectedMerchantStatus = watch("merchantStatusType");
    // const isPassiveSelected = selectedMerchantStatus === "PASSIVE";
    const [selectedCity, setSelectedCity] = useState(null as any);
    const [selectedMcc, setSelectedMcc] = useState(null as any);
    const [selectedIntegrationType, setSelectedIntegrationType] = useState(null as any);
    const [selectedMerchant, setSelectedMerchant] = useState(0);
    const [isPaymentDescriptionActiveState, setIsPaymentDescriptionActiveState] = useState(false);
    const [isUnlimitedLink, setIsUnlimitedLink] = useState(false);
    const [isIntegrationStatusActive, setIsIntegrationStatusActive] = useState(false);
    const [selectedUserPortfolio, setSelectedUserPortfolio] = useState(null as any);
    const [selectedCompanyType, setSelectedCompanyType] = useState(null as any);
    const [integratorMerchantId, setIntegratorMerchantId] = useState(null as any);
    const setSnackbar = useSetSnackBar();

    useEffect(() => {
        selectedCity &&
            getTaxAdministrationList(
                { cityCode: `${selectedCity.value}` },
                {
                    onSuccess(data) {
                        const tempData = data?.data?.map(
                            (item: { name: string; taxAdministrationCode: string }) => {
                                return {
                                    label: item.name,
                                    value: `${item.taxAdministrationCode}`,
                                };
                            }
                        );
                        setTaxAdministrations(tempData);
                    },
                }
            );
    }, [getTaxAdministrationList, selectedCity]);

    const merchantTypes = useMemo(() => {
        return rawMerchantTypes?.data?.map(
            (merchantType: { value: string; key: number }) => {
                return {
                    label: merchantType.value,
                    value: `${merchantType.key}`,
                };
            }
        );
    }, [rawMerchantTypes?.data]);

    const integrationTypes = useMemo(() => {
        return rawIntegraionTypes?.data?.map(
            (iType: { value: string; id: number }) => {
                return {
                    label: iType.value,
                    value: `${iType.id}`,
                };
            }
        );
    }, [rawIntegraionTypes?.data]);

    const sectors = useMemo(() => {
        return rawSectorList?.data?.result?.map(
            (iType: { sectorName: string; id: number }) => {
                return {
                    label: iType.sectorName,
                    value: `${iType.id}`,
                };
            }
        );
    }, [rawSectorList?.data]);

    const merchantStatuses = useMemo(() => {
        return rawMerchantStatus?.data?.map(
            (merchantStat: { value: string; key: number }) => {
                return {
                    label: merchantStat.key,
                    value: `${merchantStat.value}`,
                };
            }
        );
    }, [rawMerchantStatus?.data]);

    const posTypes = useMemo(() => {
        return rawPosTypes?.data?.map(
            (rawPosType: { key: string; value: string }) => {
                return {
                    label: rawPosType.value,
                    value: rawPosType.key,
                };
            }
        );
    }, [rawPosTypes?.data]);



    const annulmentCodes = useMemo(() => {
        return rawAnnulmentCode?.data?.map(
            (annulment: { description: string; code: string }) => {
                return {
                    label: annulment.description,
                    value: annulment.code,
                };
            }
        );
    }, [rawAnnulmentCode?.data]);


    const merchantAllList = useMemo(() => {
        return rawMerchantList?.data?.map(
            (rawPosType: { merchantName: string; merchantId: number }) => {
                return {
                    label: rawPosType.merchantName,
                    value: rawPosType.merchantId,
                };
            }
        );
    }, [rawMerchantList?.data]);

    const merchantList = useMemo(() => {
        if (userInfo.merchantId == 0) {
            return rawMerchantList?.data?.map(
                (rawPosType: { merchantName: string; merchantId: number }) => {
                    return {
                        label: rawPosType.merchantName,
                        value: rawPosType.merchantId,
                    };
                }
            );
        } else {
            return rawMerchantList?.data
                ?.filter((rawPosType: { merchantName: string; merchantId: number }) => {
                    return rawPosType.merchantId === Number(userInfo.merchantId);
                })
                .map((filteredMerchant) => {
                    return {
                        label: filteredMerchant.merchantName,
                        value: filteredMerchant.merchantId,
                    };
                });
        }
    }, [rawMerchantList?.data, userInfo.merchantId, isMerchantListLoading]);

    const [formState, setFormState] = useState<MerchantAddFormAuthorizationSectionFormStates>({
        isUnlimitedLinkActive: false,
        isLinkCreationActive: false,
        isNonSecureActive: false,
        linkPaymentExpireInHour: 0,
        linkQuantity: 1
    });

    const [formStateLimit, setFormStateLimit] = useState<MerchantAddFormLimitSectionFormStates>({
        hasGiroRestriction: false,
        hasAutomaticGiroLimitIncrease: false,
        commercialFlag: false,
        giroLimit: 0,
        corporateFlag: false
    });

    const commissionProfileList = useMemo(() => {
        return rawCommissionProfileList?.data?.result?.map(
            (rawPosType: { name: string; code: string }) => {
                return {
                    label: rawPosType.name,
                    value: `${rawPosType.code}`,
                };
            }
        );
    }, [rawCommissionProfileList?.data?.result]);

    const cityList = useMemo(() => {
        return rawCityList?.data?.map(
            (city: { name: string; cityCode: string }) => {
                return {
                    label: city.name,
                    value: city.cityCode,
                };
            }
        );
    }, [rawCityList?.data]);

    const userPortfolioList = useMemo(() => {
        return rawUserPortfolioList?.data?.map((user: { id: number; fullName: string; mail: string }) => {
            return { label: user.fullName + ` (${user.mail})`, value: `${user.id}` };
        });
    }, [rawUserPortfolioList?.data]);

    const merchantCategoryList = useMemo(() => {
        return rawMerchantCategoryList?.data?.map(
            (rawMerchantCategory: { description: string; code: string }) => {
                return {
                    label: `${rawMerchantCategory.code} - ${rawMerchantCategory.description}`,
                    value: `${rawMerchantCategory.code}`,
                };
            }
        );
    }, [rawMerchantCategoryList?.data]);

    const originalMccList = useMemo(() => {
        const list = rawMerchantCategoryList?.data?.map(
            (rawMerchantCategory: { description: string; code: string }) => {
                return {
                    label: rawMerchantCategory.code,
                    value: rawMerchantCategory.code,
                };
            }
        );
        return list;
    }, [rawMerchantCategoryList?.data]);

    const merchantPassiveReasons = useMemo(() => {
        return rawMerchantPassiveReasons?.data?.map(
            (reason: { description: string }) => {
                return {
                    label: reason.description,
                    value: reason.description,
                };
            }
        );
    }, [rawMerchantPassiveReasons?.data]);

    const onSubmit = ({
        merchantStatusType,
        parentMerchantId,
        posList,
        taxOfficeCode,
        tradeRegistrationNumber,
        tradeName,
        aggreementDate,
        openingDate,
        mcc,
        foundationDate,
        citizenshipNumber,
        taxNumber,
        merchantType,
        merchantName,
        commissionProfileCode,
        webSite,
        closedDate,
        annulmentCode,
        hostingCompanyName,
        hostingCompanyCitizenNumber,
        status,
        annulmentStaff,
        annulmentCodeDesc,
        passiveReason,
        paymentDescriptionPlaceholder,
        linkPaymentHour,
        linkQuantity,
        giroLimit,
        integrationTypeId,
        sectorId,
        isInvoiceSendAsEmailEnabled,
        invoiceEmail,
        integratorId,
        integratorGbAlias,
        integratorEArchiveGbAlias,
        integratorUid,
        integratorPwd,
        erpCustomerCode,
        walletNo,
        eftDescription,
        paymentBlockedDay,
        blockedDay,
        originalMcc = "",
    }: FirstStepFormValuesType) => {
        const taxOffice = taxAdministrations?.find(
            (item: { value: string }) => item?.value === taxOfficeCode
        ) as unknown as { value: string; label: string };
        const selectedAnnulment = annulmentCodes.find(
            (option) => option.value === annulmentCode
        );
        const derivedAnnulmentCodeDesc = selectedAnnulment ? selectedAnnulment.label : "";

        // getValues() ile originalMcc'yi al
        const formValues = getValues();
        const finalOriginalMcc = originalMcc || formValues.originalMcc || "";

        const request: IMerchantAddRequest = {
            memberId: 1,
            merchantType: +merchantType,
            merchantStatusType,
            status: merchantStatusType,
            mobilePos: false,
            cepPos: false,
            vpos: false,
            pos: false,
            parentMerchantId: selectedMerchant?.value
                ? Number(selectedMerchant?.value)
                : 0,
            merchantName,
            tradeName,
            tradeRegistrationNumber,
            commissionProfileCode,
            webSite,
            taxNumber,
            taxOfficeCode,
            taxOfficeName: taxOffice.label,
            citizenshipNumber,
            passiveReason,
            annulmentStaff: annulmentStaff ? annulmentStaff : "",
            annulmentCodeDesc: derivedAnnulmentCodeDesc,
            hostingCompanyName: hostingCompanyName ? hostingCompanyName : "",
            hostingCompanyCitizenNumber: hostingCompanyCitizenNumber ? hostingCompanyCitizenNumber : "",
            // mcc: selectedMcc?.value,
            mcc: mcc,
            //foundationDate: "",
            openingDate: openingDate ? dayjs(openingDate).format("YYYY-MM-DD") : null,
            aggreementDate: aggreementDate
                ? dayjs(aggreementDate).format("YYYY-MM-DD")
                : null,
            closedDate: closedDate ? dayjs(closedDate).format("YYYY-MM-DD") : null,
            annulmentCode: annulmentCode ? annulmentCode : "",
            phoneNumber: "",
            description: "",
            isPaymentDescriptionActive: isPaymentDescriptionActiveState,
            ...posList,
            paymentDescriptionPlaceholder,
            integrationTypeId: integrationTypeId,
            userPortfolioId: selectedUserPortfolio,
            isUnlimitedLink: formState.isUnlimitedLink ? formState.isUnlimitedLink : false,
            linkPaymentActive: formState.isLinkCreationActive ? formState.isLinkCreationActive : false,
            linkPaymentHour: linkPaymentHour ? Number(linkPaymentHour) : 0,
            linkQuantity: linkQuantity ? Number(linkQuantity) : 0,
            restrictedLink: formState.isRestrictedLink ? formState.isRestrictedLink : false,
            nonSecure: formState.isNonSecureActive ? formState.isNonSecureActive : false,
            hasGiroRestriction: formStateLimit.hasGiroRestriction ? formStateLimit.hasGiroRestriction : false,
            hasAutomaticGiroLimitIncrease: formStateLimit.hasAutomaticGiroLimitIncrease ? formStateLimit.hasAutomaticGiroLimitIncrease : false,
            giroLimit: giroLimit,
            corporateFlag: selectedWorkplaceType?.value == 1,
            commercialFlag: selectedWorkplaceType?.value == 2,
            isOnlyTabUpdate: false,
            sectorId: Number(sectorId) ?? 0,
            isInvoiceSendAsEmailEnabled,
            invoiceEmail: invoiceEmail,
            integratorMerchantId: integratorMerchantId,
            integratorId: integratorId ? Number(integratorId) : 0,
            integratorUid: integratorUid || '',
            integratorPwd: integratorPwd || '',
            integratorGbAlias: integratorGbAlias || '',
            integratorEArchiveGbAlias: integratorEArchiveGbAlias || '',
            erpCustomerCode: erpCustomerCode || 0,
            walletNo: walletNo || '',
            eftDescription: eftDescription || '',
            paymentBlockedDay: Number(paymentBlockedDay) || null,
            blockedDay: Number(blockedDay) || null,
            originalMcc: finalOriginalMcc,
        };
        // const extendedRequest = !isPassiveSelected ? {} : {
        //   closedDate: closedDate ? dayjs(closedDate).format("YYYY-MM-DD") : null,
        //   annulmentCode: annulmentCode
        // };
        // const request = { ...baseRequest, ...extendedRequest };
        if ((merchant && merchant?.id > 0) || (allData && allData?.merchantType)) {
            updateMerchant(
                {
                    ...request,
                    id: allData?.id || 0,
                    hashPassword: merchant?.hashPassword || allData?.hashPassword || "",
                    merchantId: merchant?.merchantId || allData?.merchantId || 0,

                },
                {
                    onSuccess(data) {
                        if (data.isSuccess && selectedMerchantStatus !== "PASSIVE") {
                            const merchantId = data.data.merchant[0].merchantId;
                            setMerchantId(merchantId);
                            setAllData({ ...allData, ...request, merchantId: merchantId });
                            setSnackbar({
                                severity: "success",
                                isOpen: true,
                                description: data.message,
                            });
                        } else if (data.isSuccess && selectedMerchantStatus === "PASSIVE") {
                            setSnackbar({
                                severity: "success",
                                isOpen: true,
                                description: (
                                    <>
                                        {data.message}
                                    </>
                                ),
                            });
                        } else {
                            setSnackbar({
                                severity: "error",
                                isOpen: true,
                                description: data.message,
                            });
                        }
                    },
                    onError: (error) => {
                        setSnackbar({
                            severity: "error",
                            isOpen: true,
                            description: "İşlem sırasında bir hata oluştu",
                        });
                    },
                });
        } else {
            addMerchant(request, {
                onSuccess(data) {
                    if (data.isSuccess && selectedMerchantStatus !== "PASSIVE") {
                        const merchantId = data.data.merchantId;
                        const id = data.data.id;
                        setMerchantId(merchantId);
                        setAllData({ ...allData, ...request, merchantId: merchantId, id });
                        setSnackbar({
                            severity: "success",
                            isOpen: true,
                            description: data.message,
                        });
                    } else if (data.isSuccess && selectedMerchantStatus === "PASSIVE") {
                        setSnackbar({
                            severity: "success",
                            isOpen: true,
                            description: (
                                <>
                                    {data.message}
                                    <br />
                                    Pasif Üye İşyeri Bir sonraki Adıma Geçemez
                                </>
                            ),
                        });
                    } else if (data.isSuccess && selectedMerchantStatus === "BLACKLISTED") {
                        setSnackbar({
                            severity: "warning",
                            isOpen: true,
                            description: (
                                <>
                                    {data.message}
                                </>
                            ),
                        });
                    } else {
                        setSnackbar({
                            severity: "error",
                            isOpen: true,
                            description: data.message,
                        });
                    }
                },
                onError: (error) => {
                    setSnackbar({
                        severity: "error",
                        isOpen: true,
                        description: "İşlem sırasında bir hata oluştu",
                    });
                },
            });
        }
    };

    const city = watch("city");
    const mcc = watch("mcc");
    const originalMcc = watch("originalMcc");
    useEffect(() => {
        if (mcc && mcc !== originalMcc) {
            setValue("originalMcc", mcc);
        }
    }, [mcc, setValue]);

    useEffect(() => {
        if (originalMcc && originalMcc !== mcc) {
            const selectedMccOption = merchantCategoryList?.find(option => option.value === originalMcc);
            if (selectedMccOption) {
                setValue("mcc", originalMcc);
            }
        }
    }, [originalMcc, setValue, merchantCategoryList]);

    useEffect(() => {
        if (!!merchant && JSON.stringify(merchant) !== "{}") {
            if (selectedCity === null || selectedCity === undefined) {
                setSelectedCity(
                    cityList?.find(
                        (c: any) =>
                            c.value === merchant?.taxOfficeCityCode
                    )
                );
            }

            // if (selectedMcc === null || selectedMcc === undefined) {
            //   setSelectedMcc(
            //     merchantCategoryList?.find((mcc: any) => mcc?.value === merchant?.mcc)
            //   );
            // }

            // if (selectedMerchant === null || selectedMerchant === undefined) {

            // }

            setIsPaymentDescriptionActiveState(merchant.isPaymentDescriptionActive);
            setIsUnlimitedLink(merchant.isUnlimitedLink);
            setIsIntegrationStatusActive(merchant.integrationStatus);
            setSelectedIntegrationType(merchant.integrationTypeId);
            setSelectedUserPortfolio(merchant.userPortfolioId);
            setSelectedCompanyType(merchant.merchantType);
            setSelectedWorkplaceType(workplaceTypes.find((w) => w.value == merchant.corporateFlag ? 1 : 2));

            const isInvoiceEnabled = merchant.isInvoiceSendAsEmailEnabled || false;
            setValue('isInvoiceSendAsEmailEnabled', isInvoiceEnabled);
            setValue('invoiceEmail', merchant.invoiceEmail || '');

            reset({
                merchantType: `${merchant.merchantType}`,
                parentMerchantId: merchant.parentMerchantId,
                merchantStatusType: merchant.merchantStatusType,
                merchantName: merchant.merchantName,
                tradeName: merchant.tradeName,
                tradeRegistrationNumber: merchant.tradeRegistrationNumber,
                commissionProfileCode: merchant.commissionProfileCode,
                webSite: merchant.webSite,
                city: selectedCity,
                taxNumber: merchant.taxNumber,
                taxOfficeCode: merchant.taxOfficeCode,
                citizenshipNumber: merchant.citizenshipNumber,
                hostingCompanyName: merchant.hostingCompanyName,
                hostingCompanyCitizenNumber: merchant.hostingCompanyCitizenNumber,
                mcc: merchant.mcc,
                originalMcc: merchant.originalMcc || "",
                openingDate: dayjs(merchant.openingDate),
                aggreementDate: dayjs(merchant.aggreementDate),
                closedDate: merchant.closedDate ? dayjs(merchant.closedDate) : null,
                annulmentCode: merchant.annulmentCode,
                annulmentStaff: merchant.annulmentStaff,
                annulmentCodeDesc: merchant.annulmentCodeDesc,
                passiveReason: merchant.passiveReason ? `${merchant.passiveReason}` : "",
                isPaymentDescriptionActive: merchant.isPaymentDescriptionActive,
                postList: merchant.pos,
                paymentDescriptionPlaceholder: merchant.paymentDescriptionPlaceholder,
                posList: {
                    vpos: merchant?.vpos,
                    pos: merchant?.pos,
                    mobilePos: merchant?.mobilePos,
                    cepPos: merchant?.cepPos,
                },
                integrationTypeId: `${merchant.integrationTypeId}`,
                userPortfolioId: `${merchant.userPortfolioId}`,
                linkPaymentHour: merchant.linkPaymentHour,
                linkQuantity: merchant.linkQuantity,
                nonSecure: merchant.nonSecure,
                sectorId: merchant.sectorId,
                isInvoiceSendAsEmailEnabled: isInvoiceEnabled,
                invoiceEmail: merchant.invoiceEmail || '',
                integratorMerchantId: merchant.integratorMerchantId,
                //foundationDate: dayjs(merchant.foundationDate),
                integratorId: merchant.integratorId || 30,
                integratorUid: merchant.integratorUid || '',
                integratorPwd: merchant.integratorPwd || '',
                integratorGbAlias: merchant.integratorGbAlias || '',
                integratorEArchiveGbAlias: merchant.integratorEArchiveGbAlias || '',
                erpCustomerCode: merchant.erpCustomerCode || '',                //foundationDate: dayjs(merchant.foundationDate),
                walletNo: merchant.walletNo || '',
                eftDescription: merchant.eftDescription || '',
                linkExpireInMinutes: merchant.linkExpireInMinutes || 0,
                paymentBlockedDay: merchant.paymentBlockedDay || null,
                blockedDay: merchant.blockedDay || null,
            });
        }
    }, [
        cityList,
        merchant,
        merchantCategoryList,
        posTypes,
        reset,
        selectedCity,
        selectedMcc,
        setValue,
    ]);
    useEffect(() => {
        if (merchant && merchant.taxOfficeCode) {
            const cityCode = merchant.taxOfficeCode.substring(0, 2);
            const cityRelatedToTaxOfficeCode = cityList?.find(
                (city) => city.value === cityCode
            );

            setSelectedCity(cityRelatedToTaxOfficeCode);
        }
    }, [merchant, cityList]);

    useEffect(() => {
        if (merchant?.parentMerchantId && merchantList?.length > 0) {
            const selected = merchantList.find(
                (merc: any) => merc?.value == merchant?.parentMerchantId
            );
            if (selected != null) setSelectedMerchant(selected);
        }

    }, [merchantList, merchant])

    useEffect(() => {
        if (selectedMerchantStatus === "ACTIVE" || selectedMerchantStatus === "BLOCKED") {
            setValue("annulmentCode", ""); // annulmentCode değerini sıfırla
            setValue("annulmentStaff", "")
            setValue("annulmentCodeDesc", "")
            setValue("closedDate", null);  // closedDate değerini sıfırla
        }
    }, [selectedMerchantStatus, setValue]);

    const workplaceTypes = [
        {
            label: 'Ticari',
            value: 1
        },
        {
            label: 'Kurumsal',
            value: 2
        }
    ];
    const [selectedWorkplaceType, setSelectedWorkplaceType] = useState(null as any);

    const hasLoading =
        isMerchantCategoryLoading ||
        isLoading ||
        isMerchantListLoading ||
        isMerchantStatusLoading ||
        updateLoading ||
        isMerchantStatusLoading ||
        isMerchantTypeLoading ||
        isPosTypeLoading ||
        isCommissionProfileListLoading ||
        isCityListLoading ||
        isTaxListLoading ||
        isIntegrationTypesLoading ||
        isSectorLoading ||
        isMerchantPassiveReasonsLoading;

    // return (<>
    //     {hasLoading ? (<Loading />) : <></>}

    //     <Stack px={isDesktop ? 2 : 1} mb={3} spacing={3}>



    //     </Stack>

    // </>);
    const posListWatch = watch('posList');
    return (
        <>
            {hasLoading ? (
                <Loading />
            ) : (<>
                <Stack px={isDesktop ? 2 : 1} mb={3} spacing={1}>
                    <Stack
                        width={'100%'}
                        pt={3}
                        spacing={3}
                        direction={isDesktop ? "row" : "column"}
                    >
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            {merchantTypes && (
                                <Controller
                                    control={control}
                                    name="merchantType"
                                    render={({ field: { onChangeT, valueT }, fieldState }) => {

                                        return (
                                            <>
                                                <Autocomplete
                                                    onChange={(event, selectedValue) => {
                                                        setSelectedCompanyType(selectedValue.value);
                                                        setValue(
                                                            "merchantType",
                                                            selectedValue?.value || 0
                                                        );
                                                    }}
                                                    id="merchantType"
                                                    options={merchantTypes}
                                                    value={selectedCompanyType ? merchantTypes.find((option) => option.value == selectedCompanyType) : {}}
                                                    getOptionLabel={(option: {
                                                        label: string;
                                                        value: number;
                                                    }) => option.label ?? ""}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Şirket Tipi"
                                                            error={fieldState.invalid}
                                                        />
                                                    )}
                                                />
                                            </>
                                        );
                                    }}
                                />
                            )}
                        </FormControl>

                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            {workplaceTypes && (
                                <Controller
                                    control={control}
                                    name="workplaceType"
                                    render={(fieldState) => {

                                        return (
                                            <>
                                                <Autocomplete
                                                    onChange={(event, selectedValue) => {
                                                        setSelectedWorkplaceType(selectedValue);
                                                        setValue(
                                                            "workplaceType",
                                                            selectedValue?.value || 0
                                                        );
                                                    }}
                                                    id="workplaceType"
                                                    options={workplaceTypes}
                                                    value={selectedWorkplaceType ? selectedWorkplaceType : {}}
                                                    getOptionLabel={(option: {
                                                        label: string;
                                                        value: number;
                                                    }) => option.label ?? ""}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="İşyeri Tipi"
                                                            error={fieldState.invalid}
                                                        />
                                                    )}
                                                />
                                            </>
                                        );
                                    }}
                                />
                            )}
                        </FormControl>

                        <Box sx={{ width: isDesktop ? "50%" : "100%" }}>
                            <Typography color="text.default" variant="overline">
                                POS Tipi
                            </Typography>
                            {posTypes && (
                                <CheckboxesControl
                                    row
                                    id="posList"
                                    control={control}
                                    items={posTypes}
                                />
                            )}
                        </Box>
                    </Stack>
                    {posListWatch?.mobilePos && (
                        <>
                            <Divider sx={{ my: 2 }}>
                                <Typography variant="overline" color="text.secondary">
                                    Fatura Entegratör Bilgileri
                                </Typography>
                            </Divider>

                            <Stack
                                width={"100%"}
                                minWidth={"100%"}
                                spacing={3}
                                direction="column" // Changed to column for better organization
                                sx={{
                                    backgroundColor: 'background.paper',
                                    p: 2,
                                    borderRadius: 1,
                                    border: '1px solid',
                                    borderColor: 'divider'
                                }}
                            >
                                {/* First Row */}
                                <Stack
                                    width={"100%"}
                                    spacing={3}
                                    direction={isDesktop ? 'row' : 'column'}
                                >
                                    <ComboboxWithFreeText
                                        control={control}
                                        name="integratorGbAlias"
                                        label="E-Fatura Entegratör Gib değeri"
                                        options={gbAliasList}
                                        isDisabled={false}
                                        isLoading={isGetGbAliasLoading}
                                        state={isTaxAndInvoiceGbAliasValid ? ComboboxState.DEFAULT : ComboboxState.WARNING}
                                        stateText={"Vergi Numarası ile Girilen Etiket değeri eşleşmemektedir"}
                                    />
                                    <ComboboxWithFreeText
                                        control={control}
                                        name="integratorEArchiveGbAlias"
                                        label="E-Arşiv Entegratör Gib değeri"
                                        options={gbAliasList}
                                        isDisabled={false}
                                        isLoading={isGetGbAliasLoading}
                                        state={isTaxAndEArchiveGbAliasValid ? ComboboxState.DEFAULT : ComboboxState.WARNING}
                                        stateText={"Vergi Numarası ile Girilen Etiket değeri eşleşmemektedir"}
                                    />
                                </Stack>

                                {/* Second Row */}
                                <Stack
                                    width={"100%"}
                                    spacing={3}
                                    direction={isDesktop ? 'row' : 'column'}
                                >
                                    <Controller
                                        name="integratorId"
                                        control={control}
                                        defaultValue="30"
                                        render={({ field: { onChange, value }, fieldState }) => (
                                            <Select
                                                sx={{ width: isDesktop ? "33%" : "100%" }}
                                                value={value}
                                                onChange={onChange}
                                                disabled={true}
                                                label="Fatura Entegratör"
                                            >
                                                {integratorList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    <InputControl
                                        sx={{ width: isDesktop ? "33%" : "100%" }}
                                        id="integratorUid"
                                        control={control}
                                        label="Fatura Entegratör Kullanıcı Adı"
                                    />
                                    <InputControl
                                        sx={{ width: isDesktop ? "33%" : "100%" }}
                                        id="integratorPwd"
                                        control={control}
                                        label="Fatura Entegratör Şifresi"
                                    />
                                </Stack>
                            </Stack>
                        </>
                    )}
                    <Stack
                        width={"100%"}
                        spacing={3}
                        direction={isDesktop ? "row" : "column"}
                    >
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            {merchantList && (
                                <Controller
                                    control={control}
                                    name="parentMerchantId"
                                    render={(fieldState) => {

                                        return (
                                            <>
                                                <Autocomplete
                                                    onChange={(event, selectedValue) => {
                                                        setSelectedMerchant(selectedValue);
                                                        setValue(
                                                            "parentMerchantId",
                                                            selectedValue?.value || 0
                                                        );
                                                    }}
                                                    id="parentMerchantId"
                                                    options={merchantList}
                                                    value={selectedMerchant ? selectedMerchant : {}}
                                                    getOptionLabel={(option: {
                                                        label: string;
                                                        value: number;
                                                    }) => option.label ?? ""}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Ana İşyeri"
                                                            error={fieldState.invalid}
                                                        />
                                                    )}
                                                />
                                            </>
                                        );
                                    }}
                                />
                            )}
                        </FormControl>
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            {merchantStatuses ? (
                                <Controller
                                    name="merchantStatusType"
                                    control={control}
                                    defaultValue=""
                                    render={({ field: { onChange, value }, fieldState }) => {
                                        const selectedMerchantStatus = merchantStatuses.find(
                                            (option) => option.value === value
                                        );

                                        return (
                                            <Autocomplete
                                                id="merchantStatusType"
                                                options={merchantStatuses}
                                                getOptionSelected={(option, value) =>
                                                    option.value === value
                                                }
                                                getOptionLabel={(option) => option.label}
                                                value={selectedMerchantStatus || null}
                                                onChange={(_, newValue) => {
                                                    onChange(newValue ? newValue.value : "");
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="İşyeri Durumu"
                                                        error={fieldState.invalid}
                                                    />
                                                )}
                                            />
                                        );
                                    }}
                                />
                            ) : null}
                        </FormControl>
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            <InputControl
                                id="merchantName"
                                control={control}
                                label="İşyeri Adı"
                            />
                        </FormControl>
                    </Stack>
                    <Stack
                        width={"100%"}
                        spacing={3}
                        direction={isDesktop ? "row" : "column"}
                    >
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            <InputControl
                                id="tradeName"
                                control={control}
                                label="İşyeri Ticari Adı"
                            />
                        </FormControl>
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            <InputControl
                                id="tradeRegistrationNumber"
                                control={control}
                                label="Sicil No"
                                numeric
                            />
                        </FormControl>
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            {commissionProfileList ? (
                                <Controller
                                    name="commissionProfileCode"
                                    control={control}
                                    defaultValue=""
                                    render={({ field: { onChange, value }, fieldState }) => {
                                        const selectedCommissionProfile =
                                            commissionProfileList.find(
                                                (option) => option.value === value
                                            );

                                        return (
                                            <Autocomplete
                                                id="commissionProfileCode"
                                                options={commissionProfileList}
                                                getOptionSelected={(option, value) =>
                                                    option.value === value
                                                }
                                                getOptionLabel={(option) => option.label}
                                                value={selectedCommissionProfile || null}
                                                onChange={(_, newValue) => {
                                                    onChange(newValue ? newValue.value : "");
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Çalışma Grubu"
                                                        error={fieldState.invalid}
                                                    />
                                                )}
                                            />
                                        );
                                    }}
                                />
                            ) : null}
                        </FormControl>
                    </Stack>
                    <Stack
                        width={"100%"}
                        spacing={3}
                        direction={isDesktop ? "row" : "column"}
                    >
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            <InputControl
                                id="webSite"
                                control={control}
                                label="Web Sitesi"
                            />
                        </FormControl>
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            {cityList && (
                                <Controller
                                    control={control}
                                    name="city"
                                    render={({ field: { onChange, value }, fieldState }) => {
                                        return (
                                            <>
                                                <Autocomplete
                                                    id="city"
                                                    options={cityList}
                                                    value={selectedCity || null}
                                                    onChange={(event, selectedValue) => {
                                                        setSelectedCity(selectedValue);
                                                        onChange(selectedValue);
                                                    }}
                                                    getOptionLabel={(option: {
                                                        label: string;
                                                        value: number;
                                                    }) => option.label}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Vergi Dairesi İli"
                                                            error={fieldState.invalid}
                                                        />
                                                    )}
                                                />
                                            </>
                                        );
                                    }}
                                />
                            )}
                        </FormControl>
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            <InputControl
                                id="taxNumber"
                                control={control}
                                label="Vergi Numarası"
                                numeric
                                maxLength={10}
                            />
                        </FormControl>
                    </Stack>

                    <Stack
                        width={"100%"}
                        spacing={3}
                        direction={isDesktop ? "row" : "column"}
                    >
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            {taxAdministrations ? (
                                <Controller
                                    name="taxOfficeCode"
                                    control={control}
                                    defaultValue=""
                                    rules={{ required: true }}
                                    render={({ field: { onChange, value }, fieldState }) => {
                                        const selectedTaxAdministration = taxAdministrations.find(
                                            (option) => option.value === value
                                        );

                                        return (
                                            <Autocomplete
                                                id="taxOfficeCode"
                                                options={taxAdministrations}
                                                getOptionSelected={(option, value) =>
                                                    option.value === value
                                                }
                                                getOptionLabel={(option) => option.label}
                                                value={selectedTaxAdministration || null}
                                                onChange={(_, newValue) => {
                                                    onChange(newValue ? newValue.value : "");
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Vergi Dairesi"
                                                        error={fieldState.invalid}
                                                    />
                                                )}
                                            />
                                        );
                                    }}
                                />
                            ) : null}
                        </FormControl>

                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            <InputControl
                                id="citizenshipNumber"
                                control={control}
                                label="Kimlik Numarası"
                                numeric
                                maxLength={11}
                            />
                        </FormControl>

                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            {merchantCategoryList && (
                                <Controller
                                    control={control}
                                    name="mcc"
                                    defaultValue=""
                                    rules={{ required: true }} // Bu satırı ekledik, böylece alanın doldurulması zorunlu olur.
                                    render={({ field: { onChange, value }, fieldState }) => {
                                        const selectedMerchantCategory =
                                            merchantCategoryList.find(
                                                (option) => option.value === value
                                            );

                                        return (
                                            <>
                                                <Autocomplete
                                                    options={merchantCategoryList}
                                                    getOptionLabel={(option) => option.label}
                                                    value={selectedMerchantCategory || null}
                                                    onChange={(_, newValue) => {
                                                        const newVal = newValue ? newValue.value : "";
                                                        onChange(newVal);
                                                        if (newVal) {
                                                            setValue("originalMcc", newVal);
                                                        }
                                                    }}

                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="MCC"
                                                            error={fieldState.invalid}
                                                        />
                                                    )}
                                                />
                                            </>
                                        );
                                    }}
                                />
                            )}
                        </FormControl>
                    </Stack>
                       <Stack
                        width={"100%"}
                        spacing={3}
                        direction={isDesktop ? "row" : "column"}
                    >
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            {originalMccList && (
                                <Controller
                                    control={control}
                                    name="originalMcc"
                                    defaultValue=""
                                    rules={{ required: true }}
                                    render={({ field: { onChange, value }, fieldState }) => {
                                        const selectedOriginalMcc = originalMccList.find(
                                            (option) => option.value === value
                                        );

                                        return (
                                            <Autocomplete
                                                options={originalMccList}
                                                getOptionLabel={(option) => option.label}
                                                value={selectedOriginalMcc || null}
                                                onChange={(_, newValue) => {
                                                    const newVal = newValue ? newValue.value : "";
                                                    onChange(newVal);
                                                    if (newVal) {
                                                        const selectedMccOption = merchantCategoryList?.find(option => option.value === newVal);
                                                        if (selectedMccOption) {
                                                            setValue("mcc", newVal);
                                                        }
                                                    }
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Original MCC"
                                                        error={fieldState.invalid}
                                                    />
                                                )}
                                            />
                                        );
                                    }}
                                />
                            )}
                        </FormControl>
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            {/* İleride başka bir alan eklenebilir */}
                        </FormControl>
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            {/* İleride başka bir alan eklenebilir */}
                        </FormControl>
                    </Stack>
                    <Stack
                        width={"100%"}
                        spacing={3}
                        direction={isDesktop ? "row" : "column"}
                    >
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            <DatePickerControl
                                id="openingDate"
                                control={control}
                                label="İşyeri Açılış Tarihi"
                                defaultValue={dayjs()}
                            />
                        </FormControl>
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            <DatePickerControl
                                id="aggreementDate"
                                control={control}
                                label="İşyeri Sözleşme Başlangıç Tarihi"
                                defaultValue={dayjs()}
                            />
                        </FormControl>
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            <DatePickerControl
                                id="closedDate"
                                control={control}
                                label="İşyeri Sözleşme Bitiş Tarihi "
                                disabled={!isPassiveSelected}
                                defaultValue={dayjs()}
                            />
                        </FormControl>
                    </Stack>
                    <Stack
                        width={"100%"}
                        spacing={3}
                        direction={isDesktop ? "row" : "column"}
                    >
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            <InputControl
                                id="hostingCompanyName"
                                control={control}
                                label="Hosting Şirket Adı"
                            />
                        </FormControl>
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            <InputControl
                                id="hostingCompanyCitizenNumber"
                                control={control}
                                label="Hosting Şirket TCKN/VKN"
                                numeric
                                minLength={10}
                                maxLength={11}
                            />
                        </FormControl>
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            {annulmentCodes ? (
                                <Controller
                                    name="annulmentCode"
                                    control={control}
                                    defaultValue=""
                                    render={({ field: { onChange, value }, fieldState }) => {
                                        const selectedAnnulmentCode =
                                            annulmentCodes.find(
                                                (option) => option.value === value
                                            );

                                        return (
                                            <Autocomplete
                                                disabled={!isPassiveSelected}
                                                id="annulmentCode"
                                                options={annulmentCodes}
                                                getOptionSelected={(option, value) =>
                                                    option.value === value
                                                }
                                                getOptionLabel={(option) => option.label}
                                                value={selectedAnnulmentCode || null}
                                                onChange={(_, newValue) => {
                                                    onChange(newValue ? newValue.value : "");
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Fesih Nedeni"
                                                        error={fieldState.invalid}
                                                    />
                                                )}
                                            />
                                        );
                                    }}
                                />
                            ) : null}
                        </FormControl>
                    </Stack>
                    <Stack
                        width={"100%"}
                        spacing={3}
                        direction={isDesktop ? "row" : "column"}
                    >
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            <InputControl
                                id="annulmentStaff"
                                control={control}
                                label="Fesih Personel Adı Soyadı"
                                isDisabled={!isPassiveSelected}

                            />
                        </FormControl>
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            <ComboboxWithFreeText
                                control={control}
                                name="passiveReason"
                                label="Kapama Nedeni"
                                options={merchantPassiveReasons?.map(reason => ({
                                    label: reason.label,
                                    value: reason.label
                                })) || []}
                                isDisabled={!isPassiveSelected}
                                defaultValue=""
                            />
                        </FormControl>
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            {userPortfolioList ? (
                                <Controller
                                    name="userPortfolioId"
                                    control={control}
                                    defaultValue=""
                                    render={({ field: { onChange, value }, fieldState }) => {

                                        var getSelected = userPortfolioList.find(x => x.value == value);

                                        return (
                                            <Autocomplete
                                                id="userPortfolioId"
                                                options={userPortfolioList}
                                                getOptionSelected={(option, value) =>
                                                    option.value === value
                                                }
                                                getOptionLabel={(option) => option.label}
                                                value={getSelected || null}
                                                onChange={(_, newValue) => {
                                                    setSelectedUserPortfolio(newValue?.value);
                                                    onChange(newValue ? newValue.value : "");
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Satış Portföy"
                                                        error={fieldState.invalid}
                                                    />
                                                )}
                                            />
                                        );
                                    }}
                                />
                            ) : null}
                        </FormControl>
                    </Stack>

                    <Stack
                        width={"100%"}
                        spacing={3}
                        direction={isDesktop ? "row" : "column"}
                    >

                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }} >
                            <InputControl
                                id="paymentDescriptionPlaceholder"
                                control={control}
                                label="Müşterinin görüntüleyici ödeme açıklaması"
                                isDisabled={!isPaymentDescriptionActiveState}
                            />
                            {errors?.paymentDescriptionPlaceholder && <span>{errors?.paymentDescriptionPlaceholder?.message}</span>}
                        </FormControl>

                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            {merchantAllList ? (
                                <Controller
                                    name="integratorMerchantId"
                                    control={control}
                                    defaultValue=""
                                    render={({ field: { onChange, value }, fieldState }) => {

                                        var getSelected = merchantAllList.find(x => x.value == value);

                                        return (
                                            <Autocomplete
                                                id="integratorMerchantId"
                                                options={merchantAllList}
                                                getOptionSelected={(option, value) =>
                                                    option.value === value
                                                }
                                                getOptionLabel={(option) => option.label}
                                                value={getSelected || null}
                                                onChange={(_, newValue) => {
                                                    setIntegratorMerchantId(newValue?.value);
                                                    onChange(newValue ? newValue.value : "");
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Entegratör Firma"
                                                        error={fieldState.invalid}
                                                    />
                                                )}
                                            />
                                        );
                                    }}
                                />
                            ) : null}
                        </FormControl>

                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            {integrationTypes ? (
                                <Controller
                                    name="integrationTypeId"
                                    control={control}
                                    defaultValue=""
                                    render={({ field: { onChange, value }, fieldState }) => {

                                        var getSelected = integrationTypes.find(x => x.value == value);

                                        return (
                                            <Autocomplete
                                                id="integrationTypeId"
                                                options={integrationTypes}
                                                getOptionSelected={(option, value) =>
                                                    option.value === value
                                                }
                                                getOptionLabel={(option) => option.label}
                                                value={getSelected || null}
                                                onChange={(_, newValue) => {
                                                    setSelectedIntegrationType(newValue?.value);
                                                    onChange(newValue ? newValue.value : "");
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Entegrasyon Durumu"
                                                        error={fieldState.invalid}
                                                    />
                                                )}
                                            />
                                        );
                                    }}
                                />
                            ) : null}
                        </FormControl>

                    </Stack>
                    <Stack
                        width={"100%"}
                        spacing={3}
                        direction={isDesktop ? "row" : "column"}
                    >
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            {sectors ? (
                                <Controller
                                    name="sectorId"
                                    control={control}
                                    defaultValue=""
                                    render={({ field: { onChange, value }, fieldState }) => {

                                        var getSelected = sectors.find(x => x.value == value);

                                        return (
                                            <Autocomplete
                                                id="sectorId"
                                                options={sectors}
                                                getOptionSelected={(option, value) =>
                                                    option.value === value
                                                }
                                                getOptionLabel={(option) => option.label}
                                                value={getSelected || null}
                                                onChange={(_, newValue) => {
                                                    setSelectedIntegrationType(newValue?.value);
                                                    onChange(newValue ? newValue.value : "");
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Sektör"
                                                        error={fieldState.invalid}
                                                    />
                                                )}
                                            />
                                        );
                                    }}
                                />
                            ) : null}
                        </FormControl>

                        <FormControl sx={{ width: isDesktop ? "50%" : "100%", alignSelf: 'center', alignItems: 'center' }}>
                            <FormGroup>

                                <FormControlLabel
                                    control={
                                        <>
                                            <Checkbox control={control} checked={isPaymentDescriptionActiveState} onChange={() => { setIsPaymentDescriptionActiveState(!isPaymentDescriptionActiveState) }} name="isPaymentDescriptionActive" id="isPaymentDescriptionActive" />
                                            <label>Ödeme ekranında açıklama yazılmasını ister misin?</label>
                                        </>
                                    }
                                    label=""
                                />
                            </FormGroup>
                        </FormControl>
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            <FormControlLabel
                                control={
                                    <Controller
                                        name="isInvoiceSendAsEmailEnabled"
                                        control={control}
                                        defaultValue={false}
                                        render={({ field: { value, onChange } }) => (
                                            <Checkbox
                                                checked={value}
                                                onChange={(e) => {
                                                    onChange(e.target.checked);
                                                }}
                                            />
                                        )}
                                    />
                                }
                                label="Ekstre Gönderimi Aktif mi?"
                            />
                        </FormControl>


                    </Stack>
                    <Stack
                        width={"100%"}
                        spacing={3}
                        direction={isDesktop ? "row" : "column"}
                    >
                        <FormControl sx={{ width: isDesktop ? "32.5%" : "100%" }}>
                            <Controller
                                name="invoiceEmail"
                                control={control}
                                defaultValue=""
                                render={({ field, fieldState }) => (
                                    <TextField
                                        {...field}
                                        label="Ekstre Email (birden fazla mail eklemek isterseniz virgül ile ayırın)"
                                        type="text"
                                        disabled={!watch('isInvoiceSendAsEmailEnabled')}
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                    />
                                )}
                            />
                        </FormControl>
                    </Stack>
                    <Stack width={'100%'}
                        spacing={3}
                        direction={isDesktop ? "row" : "column"}>
                        <FormControl sx={{ width: "100%" }}>
                            <Controller
                                name="erpCustomerCode"
                                control={control}
                                defaultValue=""
                                render={({ field, fieldState }) => (
                                    <TextField
                                        {...field}
                                        label="ERP Müşteri Kodu"
                                        type="number"
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                    />
                                )}
                            />
                        </FormControl>
                        <FormControl sx={{ width: "100%" }}>
                            <Controller
                                name="walletNo"
                                control={control}
                                defaultValue=""
                                render={({ field, fieldState }) => (
                                    <TextField
                                        {...field}
                                        label="Cüzdan Numarası"
                                        type="number"
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                    />
                                )}
                            />
                        </FormControl>
                        <FormControl sx={{ width: "100%" }}>
                            <Controller
                                name="eftDescription"
                                control={control}
                                defaultValue=""
                                render={({ field, fieldState }) => (
                                    <TextField
                                        {...field}
                                        label="EFT Ödeme Açıklaması"
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                    />
                                )}
                            />
                        </FormControl>
                    </Stack>
                    <Stack
                        width={"100%"}
                        spacing={3}
                        direction={isDesktop ? "row" : "column"}
                    >
                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            <InputControl
                                id="paymentBlockedDay"
                                control={control}
                                label="Ödeme Bloke Günü"
                                type="number"
                                numeric
                            />
                        </FormControl>

                        <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                            <InputControl
                                id="blockedDay"
                                control={control}
                                label="Bloke Günü"
                                type="number"
                                numeric
                            />
                        </FormControl>
                    </Stack>
                </Stack>
                {!!showCreate && (
                    <Button
                        fullWidth={false}
                        sx={{ width: '100px', alignSelf: 'flex-end', marginRight: '10px' }}
                        variant="contained"
                        text="Kaydet"
                        onClick={handleSubmit(onSubmit)}
                    />
                )}

                {allData.merchantId > 0 ? (<><_MerchantTabs merchant={allData} allData={allData} setAllData={setAllData} control={control} workplaceType={workplaceTypes} formState={formState} setFormState={setFormState} getValues={getValues} merchantId={merchantId || allData?.merchantId} /></>) : <></>}
                {/* <Stack
                    width={"100%"}
                    spacing={2}
                    direction={isDesktop ? "column" : "column"}>
                    <MerchantAddFormTypeSection merchant={merchant} control={control} formState={formStateType} setFormState={setFormStateType} />
                    <MerchantAddFormAuthorizationSection merchant={merchant} control={control} formState={formState} setFormState={setFormState} />
                    <MerchantAddFormLimitSection merchant={merchant} control={control} formState={formStateLimit} formStateType={formStateType} setFormState={setFormStateLimit} setValue={setValue} />
                </Stack>
                <Stack
                    borderTop="1px solid #E6E9ED"
                    direction="row"
                    py={2}
                    px={4}
                    justifyContent="flex-end"
                >
                    {!!showCreate && (
                        <Button
                            variant="contained"
                            text="Devam"
                            onClick={handleSubmit(onSubmit)}
                        />
                    )}
                </Stack> */}


            </>
            )}
        </>
    );
};
